import { combineReducers } from 'redux';

import * as reducers from "./ducks";

export { GameStateActions } from './ducks/game-state';

export default combineReducers(reducers);
